(function() {
  /* --header-height (80px) controls the logo-bar height in header.liquid,
     so we must NOT overwrite it. Instead, measure the full sticky header
     (trust banner + logo bar + nav bar) and store it in a separate
     --co-header-offset variable for sticky tops and scroll-margin. */
  var _lastH = 0, _lastP = 0;
  function syncOffsets() {
    var hdr = document.querySelector('#shopify-section-header')
           || document.querySelector('.site-header-wrapper');
    var pill = document.querySelector('.co-pillnav');
    if (hdr) {
      var h = Math.ceil(hdr.getBoundingClientRect().height);
      /* On mobile the header collapses on scroll (header.liquid). The
         section keeps a constant height there by design, so read the
         VISIBLE header height it publishes instead, or the pill nav
         floats 125px below the collapsed header. */
      var vis = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--maw-header-visible-h'));
      if (vis > 0) h = Math.ceil(vis);
      if (h > 0 && h !== _lastH) {
        _lastH = h;
        document.documentElement.style.setProperty('--co-header-offset', h + 'px');
      }
    }
    if (pill) {
      var p = Math.ceil(pill.getBoundingClientRect().height);
      if (p > 0 && p !== _lastP) {
        _lastP = p;
        document.documentElement.style.setProperty('--co-pillnav-height', p + 'px');
      }
    }
  }
  syncOffsets();
  window.addEventListener('load', syncOffsets);
  window.addEventListener('resize', function() { _lastH = 0; _lastP = 0; syncOffsets(); });
  window.addEventListener('maw:header-collapse', function() { _lastH = 0; syncOffsets(); });

  /* Fix sticky: any ancestor with overflow hidden / auto / scroll kills position:sticky.
     Walk every ancestor of .co-filters and force overflow:visible. overflow: clip is left
     alone: it creates no scroll container (.site-wrapper uses it to trim 100vw sections). */
  var filters = document.querySelector('.co-filters');
  if (filters) {
    var el = filters.parentElement;
    while (el && el !== document.documentElement) {
      var cs = window.getComputedStyle(el);
      if (/hidden|auto|scroll/.test(cs.overflowX + ' ' + cs.overflowY)) el.style.overflow = 'visible';
      el = el.parentElement;
    }
  }

  /* FAQ accordion */
  var faqList = document.getElementById('co-faq-list');
  if (faqList) {
    faqList.addEventListener('click', function(e) {
      var btn = e.target.closest('.co-faq-q');
      if (!btn) return;
      var item = btn.closest('.co-faq-item');
      var answer = item.querySelector('.co-faq-a');
      var isOpen = item.classList.contains('is-open');
      if (isOpen) {
        answer.style.maxHeight = '0';
        item.classList.remove('is-open');
        btn.setAttribute('aria-expanded', 'false');
      } else {
        answer.style.maxHeight = answer.scrollHeight + 'px';
        item.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  }

  /* Video lazy-load (works for hero + any other co-video-container) */
  var videoContainers = document.querySelectorAll('.co-video-container[data-video-id]');
  videoContainers.forEach(function(container) {
    container.addEventListener('click', function() {
      var id = container.getAttribute('data-video-id');
      if (!id) return;
      var iframe = document.createElement('iframe');
      iframe.style.cssText = 'position:absolute;top:0;left:0;width:100%;height:100%;border:0;';
      iframe.setAttribute('src', 'https://www.youtube.com/embed/' + id + '?autoplay=1&rel=0');
      iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
      iframe.setAttribute('allowfullscreen', '');
      iframe.setAttribute('loading', 'lazy');
      container.innerHTML = '';
      container.style.cursor = 'default';
      container.appendChild(iframe);
    });
  });

  /* Sort by redirect */
  var sortSelect = document.getElementById('CoSortBy');
  if (sortSelect) {
    sortSelect.addEventListener('change', function() {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', this.value);
      window.location.href = url.toString();
    });
  }

  /* Hero call callout: toggle is-online/is-offline on the green dot
     mirroring custom-chat-trigger.liquid (8am-5pm Eastern, every day) */
  (function() {
    var dot = document.getElementById('hero-status-dot');
    var txt = document.getElementById('hero-expert-text');
    if (!dot) return;
    function isBusinessHours() {
      try {
        var now = new Date();
        var et = new Date(now.toLocaleString('en-US', { timeZone: 'America/New_York' }));
        var h = et.getHours();
        return h >= 8 && h < 17;
      } catch (e) { return true; }
    }
    function getLocalOpenHour() {
      try {
        var now = new Date();
        var et = new Date(now.toLocaleString('en-US', { timeZone: 'America/New_York' }));
        var diff = now.getHours() - et.getHours();
        if (diff > 12) diff -= 24;
        if (diff < -12) diff += 24;
        var lh = 8 + diff;
        if (lh < 0) lh += 24;
        if (lh >= 24) lh -= 24;
        return lh;
      } catch (e) { return 8; }
    }
    function fmt(h) {
      if (h === 0 || h === 24) return '12 AM';
      if (h === 12) return '12 PM';
      return h > 12 ? (h - 12) + ' PM' : h + ' AM';
    }
    var online = isBusinessHours();
    dot.classList.add(online ? 'is-online' : 'is-offline');
    if (!online && txt) {
      txt.innerHTML = 'Leave a voicemail &middot; Back at ' + fmt(getLocalOpenHour());
    }
  })();

  /* Pillnav active-state on scroll + mobile disclosure */
  var pillnav = document.getElementById('co-pillnav');
  var pillnavMobile = document.getElementById('co-pillnav-mobile');
  var pillnavTrigger = document.getElementById('co-pillnav-trigger');
  var pillnavSheet = document.getElementById('co-pillnav-sheet');
  var pillnavBackdrop = document.getElementById('co-pillnav-backdrop');
  var pillnavActiveLabel = document.getElementById('co-pillnav-active-label');
  var sheetLinks = pillnavSheet ? pillnavSheet.querySelectorAll('.co-pillnav-sheet-link') : [];

  if (pillnav && 'IntersectionObserver' in window) {
    var pills = pillnav.querySelectorAll('.co-pill');
    /* sectionMap[id] = { pill, sheetLink, label } */
    var sectionMap = {};
    pills.forEach(function(pill) {
      var id = pill.getAttribute('href').replace('#','');
      var el = document.getElementById(id);
      if (el) sectionMap[id] = { pill: pill, sheetLink: null, label: pill.textContent.trim() };
    });
    sheetLinks.forEach(function(link) {
      var id = link.getAttribute('href').replace('#','');
      if (sectionMap[id]) sectionMap[id].sheetLink = link;
    });

    function setActive(id) {
      var entry = sectionMap[id];
      if (!entry) return;
      pills.forEach(function(p) { p.classList.remove('co-pill--active'); });
      sheetLinks.forEach(function(l) { l.classList.remove('is-active'); });
      entry.pill.classList.add('co-pill--active');
      if (entry.sheetLink) entry.sheetLink.classList.add('is-active');
      if (pillnavActiveLabel) pillnavActiveLabel.textContent = entry.label;
      /* Center the active pill in the horizontal scroller (desktop/tablet insurance). */
      var inner = document.getElementById('co-pillnav');
      if (inner && inner.scrollWidth > inner.clientWidth) {
        var pillRect = entry.pill.getBoundingClientRect();
        var innerRect = inner.getBoundingClientRect();
        var offset = (pillRect.left - innerRect.left) - (innerRect.width / 2) + (pillRect.width / 2);
        inner.scrollTo({ left: inner.scrollLeft + offset, behavior: 'smooth' });
      }
    }

    var obs = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting && sectionMap[entry.target.id]) setActive(entry.target.id);
      });
    }, { rootMargin: '-40% 0px -55% 0px', threshold: 0 });
    Object.keys(sectionMap).forEach(function(id) {
      var el = document.getElementById(id);
      if (el) obs.observe(el);
    });
  }

  /* Mobile "Jump to" disclosure */
  if (pillnavMobile && pillnavTrigger && pillnavSheet) {
    function closeSheet() {
      pillnavMobile.classList.remove('is-open');
      pillnavTrigger.setAttribute('aria-expanded', 'false');
      if (pillnavBackdrop) {
        pillnavBackdrop.classList.remove('is-visible');
        pillnavBackdrop.setAttribute('hidden', '');
      }
    }
    function openSheet() {
      pillnavMobile.classList.add('is-open');
      pillnavTrigger.setAttribute('aria-expanded', 'true');
      if (pillnavBackdrop) {
        pillnavBackdrop.removeAttribute('hidden');
        /* next frame so the display:block tick before the visible class for any future transition */
        requestAnimationFrame(function() { pillnavBackdrop.classList.add('is-visible'); });
      }
    }
    pillnavTrigger.addEventListener('click', function(e) {
      e.stopPropagation();
      if (pillnavMobile.classList.contains('is-open')) closeSheet(); else openSheet();
    });
    sheetLinks.forEach(function(link) {
      link.addEventListener('click', function() { closeSheet(); });
    });
    if (pillnavBackdrop) pillnavBackdrop.addEventListener('click', closeSheet);
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && pillnavMobile.classList.contains('is-open')) closeSheet();
    });
    /* Close if viewport grows past mobile breakpoint while sheet is open */
    window.addEventListener('resize', function() {
      if (window.innerWidth > 768 && pillnavMobile.classList.contains('is-open')) closeSheet();
    });
  }

  /* =============================================================
     Generic filter + sizing engine (data-driven)
     =============================================================
     This block was previously hardcoded to iron filter axes (iron,
     household, GPM, hardness) and iron-specific recommend() rules.
     It now reads everything from:
       - #co-filter-specs   : per-product system_specs
       - #co-sizing-data    : sizing_rule + addon_rules + sizing rows
       - DOM data-axis-*    : filter_axes rendered in the sidebar
     so any cluster (iron, AN, softener, carbon, ...) renders the
     same engine without per-cluster JS edits.
     ============================================================= */
  var specsEl = document.getElementById('co-filter-specs');
  var dataElGlobal = document.getElementById('co-sizing-data');
  var SPECS = {};
  if (specsEl) { try { SPECS = JSON.parse(specsEl.textContent) || {}; } catch (e) { console.error('co: bad SPECS', e); } }

  /* ---- Discover filter axes from rendered DOM ------------------- */
  var AXES = {};
  document.querySelectorAll('input[data-axis-kind="range"]').forEach(function(el) {
    var def = parseFloat(el.dataset.axisDefault) || 0;
    var sliderMin = parseFloat(el.min);
    var sliderMax = parseFloat(el.max);
    /* Where the default sits on the slider determines which way the user
       is sliding to provide input. If default is at (or near) the slider
       min, the user slides UP to reveal their value; if at max, they
       slide DOWN. Drives the "Any" display and active-filter detection
       independently of the comparator (user_ge_spec / user_le_spec). */
    var defaultAt = 'mid';
    if (!isNaN(sliderMin) && Math.abs(def - sliderMin) < 1e-6) defaultAt = 'min';
    else if (!isNaN(sliderMax) && Math.abs(def - sliderMax) < 1e-6) defaultAt = 'max';
    AXES[el.dataset.axisKey] = {
      key: el.dataset.axisKey,
      kind: 'range',
      el: el,
      label: el.dataset.axisLabel || '',
      unit: el.dataset.axisUnit || '',
      defaultValue: def,
      defaultAt: defaultAt,
      scaleHigh: el.dataset.axisScaleHigh || '',
      compareTo: el.dataset.axisCompare || '',
      comparator: el.dataset.axisComparator || ''
    };
  });
  document.querySelectorAll('input[data-axis-kind="radio"]').forEach(function(el) {
    var k = el.dataset.axisKey;
    if (!AXES[k]) {
      AXES[k] = {
        key: k, kind: 'radio', els: [],
        label: el.dataset.axisLabel || '',
        compareTo: el.dataset.axisCompare || '',
        comparator: el.dataset.axisComparator || ''
      };
    }
    AXES[k].els.push(el);
  });
  /* select (e.g. State). state_match axes always evaluate (they hide
     state-bound products even before a state is chosen). */
  document.querySelectorAll('select[data-axis-kind="select"]').forEach(function(el) {
    var comparator = el.dataset.axisComparator || '';
    AXES[el.dataset.axisKey] = {
      key: el.dataset.axisKey,
      kind: 'select',
      el: el,
      label: el.dataset.axisLabel || '',
      compareTo: el.dataset.axisCompare || '',
      comparator: comparator,
      alwaysEvaluate: comparator === 'state_match'
    };
    /* Liquid caps metaobject-reference list loops at 50 iterations, so with
       50 states + the "any" placeholder the server-rendered select silently
       drops options. Backfill any state present in the product spec data but
       missing from the select, so the option list always matches the grid. */
    if (comparator === 'state_match') {
      var have = {};
      for (var oi = 0; oi < el.options.length; oi++) have[el.options[oi].value] = true;
      var missing = [];
      for (var h in SPECS) {
        var st = SPECS[h] && SPECS[h].state;
        if (st && !have[st] && missing.indexOf(st) === -1) missing.push(st);
      }
      missing.sort().forEach(function(st) {
        var opt = document.createElement('option');
        opt.value = st;
        opt.textContent = st;
        opt.setAttribute('data-option-kind', 'state');
        /* insert in alphabetical position (index 0 is the "any" placeholder) */
        var before = null;
        for (var ii = 1; ii < el.options.length; ii++) {
          if (el.options[ii].value > st) { before = el.options[ii]; break; }
        }
        el.insertBefore(opt, before);
      });
    }
  });
  /* checklist (e.g. contaminants). One AXES entry, many checkbox els. */
  document.querySelectorAll('input[data-axis-kind="checklist"]').forEach(function(el) {
    var k = el.dataset.axisKey;
    if (!AXES[k]) {
      AXES[k] = {
        key: k, kind: 'checklist', els: [],
        label: el.dataset.axisLabel || '',
        compareTo: el.dataset.axisCompare || '',
        comparator: el.dataset.axisComparator || 'spec_includes_all'
      };
    }
    AXES[k].els.push(el);
  });
  /* quickpick (e.g. comprehensive). A single toggle button. */
  document.querySelectorAll('button[data-axis-kind="quickpick"]').forEach(function(el) {
    AXES[el.dataset.axisKey] = {
      key: el.dataset.axisKey,
      kind: 'quickpick',
      el: el,
      label: el.dataset.axisLabel || '',
      compareTo: el.dataset.axisCompare || '',
      comparator: el.dataset.axisComparator || 'user_eq_spec'
    };
  });

  /* ---- Spec lookup helpers -------------------------------------- */
  function specValue(spec, compareTo) {
    if (!spec || !compareTo) return undefined;
    var parts = compareTo.split('.');
    if (parts[0] === 'contaminant') {
      var c = (spec.contaminants || {})[parts[1]];
      if (!c) return undefined;
      return c[parts[2]];
    }
    if (parts[0] === 'system') {
      return spec[parts[1]];
    }
    return undefined;
  }

  function axisValue(axis) {
    if (axis.kind === 'range') {
      var v = parseFloat(axis.el.value);
      return isNaN(v) ? null : v;
    }
    if (axis.kind === 'radio') {
      for (var i = 0; i < axis.els.length; i++) {
        if (axis.els[i].checked) return axis.els[i].value;
      }
      return null;
    }
    if (axis.kind === 'select') {
      return axis.el.value || '';
    }
    if (axis.kind === 'checklist') {
      var picked = [];
      axis.els.forEach(function(e) { if (e.checked) picked.push(e.value); });
      return picked;
    }
    if (axis.kind === 'quickpick') {
      return axis.el.getAttribute('aria-pressed') === 'true' ? 'yes' : null;
    }
    return null;
  }
  function axisIsActive(axis, v) {
    if (v == null) return false;
    if (axis.kind === 'range') {
      var val = parseFloat(v);
      if (axis.defaultAt === 'min') return val > axis.defaultValue;
      if (axis.defaultAt === 'max') return val < axis.defaultValue;
      return Math.abs(val - axis.defaultValue) > 1e-6;
    }
    if (axis.kind === 'radio') return v !== 'any';
    if (axis.kind === 'select') return v !== '' && v !== 'any';
    if (axis.kind === 'checklist') return Array.isArray(v) && v.length > 0;
    if (axis.kind === 'quickpick') return v === 'yes';
    return false;
  }
  function axisMatchesSpec(axis, userVal, spec) {
    var specVal = specValue(spec, axis.compareTo);
    /* state_match must run even when the product's spec value is empty
       (a blank state = national product = always shown), so it is handled
       before the generic "no spec value -> always match" short-circuit. */
    if (axis.comparator === 'state_match') {
      if (specVal === undefined || specVal === null || specVal === '') return true; // national
      if (userVal === '' || userVal === 'any' || userVal == null) return false;     // state-bound, none chosen -> hide
      return String(specVal) === String(userVal);
    }
    if (specVal === undefined || specVal === null) return true;
    switch (axis.comparator) {
      case 'user_le_spec': return parseFloat(userVal) <= parseFloat(specVal);
      case 'user_ge_spec': return parseFloat(userVal) >= parseFloat(specVal);
      case 'source_match':
        /* product water_source: well | city | both. "both" matches any
           selection; otherwise must equal the chosen source. */
        if (specVal === 'both') return true;
        return String(specVal) === String(userVal);
      case 'spec_includes_all':
        if (!Array.isArray(userVal) || userVal.length === 0) return true;
        if (!Array.isArray(specVal)) return false;
        return userVal.every(function(u) { return specVal.indexOf(u) !== -1; });
      case 'spec_includes_any':
        if (!Array.isArray(userVal) || userVal.length === 0) return true;
        if (!Array.isArray(specVal)) return false;
        return userVal.some(function(u) { return specVal.indexOf(u) !== -1; });
      case 'user_eq_spec':
        if (userVal === 'yes') return specVal === true || specVal === 'true';
        if (userVal === 'no')  return specVal === false || specVal === 'false';
        return true;
      case 'user_needs_backwash':
        /* Maps a "do you have iron / heavy sediment?" answer to the
           backwashing vs non-backwashing split via required_backwash_gpm
           (0 = upflow / non-backwashing, >0 = downflow / backwashing).
           Iron or sediment is the real reason to choose a backwashing
           system; the drain is just its install requirement. */
        var bw = parseFloat(specVal);
        if (isNaN(bw)) return true;
        if (userVal === 'yes') return bw > 0;
        if (userVal === 'no')  return bw === 0;
        return true;
      default: return true;
    }
  }

  function buildProfile() {
    var p = {};
    Object.keys(AXES).forEach(function(k) {
      var axis = AXES[k];
      var v = axisValue(axis);
      p[k] = axisIsActive(axis, v) ? v : null;
    });
    return p;
  }

  /* ---- Grid filtering ------------------------------------------- */
  var cards = document.querySelectorAll('.co-filterable');
  var catRows = document.querySelectorAll('.co-cat-row[data-cat]');
  var matchCountEl = document.getElementById('co-filter-match-count');
  /* the total is the cards that rendered, not collection.products_count: a collection can render only part of its products */
  var totalCountEl = document.getElementById('co-filter-total-count');
  if (totalCountEl) totalCountEl.textContent = cards.length;
  if (matchCountEl) matchCountEl.textContent = cards.length;
  var statusEl = document.getElementById('co-grid-status');
  var statusCountEl = document.getElementById('co-grid-status-count');
  var noResultsEl = document.getElementById('co-no-results');
  var clearBtn = document.getElementById('co-filters-clear');
  var catChecks = document.querySelectorAll('input[data-filter="cat"]');

  function isAllDefault() {
    var allDefault = Object.keys(AXES).every(function(k) {
      var axis = AXES[k];
      return !axisIsActive(axis, axisValue(axis));
    });
    var catsAll = catChecks.length === 0 || Array.prototype.every.call(catChecks, function(c) { return c.checked; });
    return allDefault && catsAll;
  }

  function filterProducts() {
    var profile = buildProfile();
    var active = !isAllDefault();
    var matchCount = 0;
    var cats = [];
    catChecks.forEach(function(c) { if (c.checked) cats.push(c.value); });

    cards.forEach(function(card) {
      var handle = card.getAttribute('data-handle');
      var spec = SPECS[handle];
      var show = true;
      if (spec) {
        if (cats.length > 0 && cats.indexOf(spec.cat) === -1) show = false;
        if (show) {
          for (var k in AXES) {
            var axis = AXES[k];
            var v = axisValue(axis);
            /* alwaysEvaluate axes (state_match) run even when "inactive",
               so state-bound clones stay hidden until their state is chosen. */
            if (!axis.alwaysEvaluate && !axisIsActive(axis, v)) continue;
            if (!axisMatchesSpec(axis, v, spec)) { show = false; break; }
          }
        }
      } else {
        if (cats.length > 0) show = false;
      }
      card.hidden = !show;
      if (show) matchCount++;
    });

    /* Float the selected state's kit to the front of its category grid so the
       state-specific test leads the section when a state is chosen. Self-gating:
       only cards with a non-empty `state` spec move, so collections without
       state-bound products (iron, AN, softener, etc.) are untouched. */
    cards.forEach(function(card) {
      if (card.hidden) return;
      var s = SPECS[card.getAttribute('data-handle')];
      if (s && s.state) {
        var ul = card.parentElement;
        if (ul && ul.firstElementChild !== card) ul.insertBefore(card, ul.firstElementChild);
      }
    });

    catRows.forEach(function(row) {
      var visibleInRow = row.querySelectorAll('.co-filterable:not([hidden])');
      row.hidden = visibleInRow.length === 0;
    });

    if (matchCountEl) matchCountEl.textContent = matchCount;
    if (statusEl) statusEl.hidden = !active;
    if (statusCountEl) statusCountEl.textContent = matchCount;
    if (noResultsEl) noResultsEl.hidden = matchCount > 0;
    if (clearBtn) clearBtn.hidden = !active;

    /* Mobile trigger badge + summary line */
    var badge = document.getElementById('co-filters-badge');
    var mobileTitle = document.getElementById('co-filters-mobile-title');
    var mobileSub = document.getElementById('co-filters-mobile-sub');
    var saveBtn = document.getElementById('co-filters-mobile-save');
    if (badge) {
      var activeCount = 0;
      Object.keys(AXES).forEach(function(k) {
        if (axisIsActive(AXES[k], axisValue(AXES[k]))) activeCount++;
      });
      if (cats.length < catChecks.length && catChecks.length > 0) activeCount++;
      badge.hidden = activeCount === 0;
      badge.textContent = activeCount;
    }
    if (mobileTitle && mobileSub) {
      if (active) {
        var parts = [];
        Object.keys(AXES).forEach(function(k) {
          var axis = AXES[k];
          var v = axisValue(axis);
          if (!axisIsActive(axis, v)) return;
          if (axis.kind === 'range') {
            var atMax = parseFloat(axis.el.max) <= parseFloat(v);
            var label = atMax && axis.scaleHigh ? axis.scaleHigh : v;
            if (axis.unit) label = label + ' ' + axis.unit;
            parts.push(label);
          } else if (axis.kind === 'radio') {
            var lbl = '';
            axis.els.forEach(function(e) {
              if (e.checked) {
                var span = e.parentElement && e.parentElement.querySelector('.co-filter-toggle-text');
                lbl = span ? span.textContent : e.value;
              }
            });
            if (lbl) parts.push((axis.label ? axis.label + ': ' : '') + lbl);
          } else if (axis.kind === 'select') {
            var optEl = axis.el.options[axis.el.selectedIndex];
            var slbl = optEl ? optEl.textContent : v;
            if (slbl) parts.push((axis.label ? axis.label + ': ' : '') + slbl);
          } else if (axis.kind === 'checklist') {
            var clabels = [];
            axis.els.forEach(function(e) {
              if (e.checked) {
                var s = e.parentElement && e.parentElement.querySelector('span');
                clabels.push(s ? s.textContent : e.value);
              }
            });
            if (clabels.length) parts.push(clabels.join(', '));
          } else if (axis.kind === 'quickpick') {
            if (axis.label) parts.push(axis.label);
          }
        });
        mobileTitle.textContent = parts.length ? parts.join(' · ') : 'Filters Active';
        mobileSub.textContent = matchCount + ' result' + (matchCount !== 1 ? 's' : '') + ' match. Tap to adjust.';
      } else {
        mobileTitle.textContent = mobileTitle.getAttribute('data-default-title') || 'Enter Your Water Test';
        mobileSub.textContent = mobileSub.getAttribute('data-default-sub') || 'See only the systems that fit your home';
      }
    }
    if (saveBtn) {
      saveBtn.textContent = active ? 'Save Filters (' + matchCount + ' result' + (matchCount !== 1 ? 's' : '') + ')' : 'Save Filters';
    }

    if (active && !document.body.classList.contains('co-filters-open')) {
      var gridSection = document.getElementById('co-products');
      if (gridSection && gridSection.getBoundingClientRect().top < 0) {
        gridSection.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }

  function updateOutputs() {
    Object.keys(AXES).forEach(function(k) {
      var axis = AXES[k];
      if (axis.kind !== 'range') return;
      var out = document.getElementById('co-f-' + k + '-out');
      if (!out) return;
      var v = parseFloat(axis.el.value);
      var max = parseFloat(axis.el.max);
      var min = parseFloat(axis.el.min);
      var unitSuffix = axis.unit ? ' ' + axis.unit : '';
      if (!axisIsActive(axis, v)) {
        out.textContent = 'Any';
      } else if (axis.defaultAt === 'min' && v >= max) {
        out.textContent = (axis.scaleHigh || (max + '+')) + unitSuffix;
      } else if (axis.defaultAt === 'max' && v <= min) {
        out.textContent = min + unitSuffix;
      } else {
        out.textContent = v + unitSuffix;
      }
    });
  }

  function resetFilters() {
    Object.keys(AXES).forEach(function(k) {
      var axis = AXES[k];
      if (axis.kind === 'range') {
        axis.el.value = axis.defaultValue;
      } else if (axis.kind === 'radio') {
        axis.els.forEach(function(e) { e.checked = e.dataset.optionKind === 'any'; });
      } else if (axis.kind === 'select') {
        var anyOpt = axis.el.querySelector('option[data-option-kind="any"]');
        axis.el.value = anyOpt ? anyOpt.value : '';
      } else if (axis.kind === 'checklist') {
        axis.els.forEach(function(e) { e.checked = false; });
      } else if (axis.kind === 'quickpick') {
        axis.el.setAttribute('aria-pressed', 'false');
        axis.el.classList.remove('is-active');
      }
    });
    catChecks.forEach(function(c) { c.checked = true; });
    ['co-f-ph', 'co-f-mn', 'co-f-hard-gpg'].forEach(function(id) {
      var el = document.getElementById(id);
      if (el) { el.value = el.defaultValue || el.min || 0; el.dataset.touched = 'false'; }
    });
    ['co-f-sulfur', 'co-f-ferric', 'co-f-bacteria'].forEach(function(id) {
      var el = document.getElementById(id);
      if (el) el.checked = false;
    });
    var drawer = document.getElementById('co-filter-drawer');
    if (drawer) drawer.open = false;
    updateOutputs();
    filterProducts();
    if (typeof refreshSizer === 'function') refreshSizer();
    if (typeof clearProfile === 'function') clearProfile();
    if (typeof updateDrawerOutputs === 'function') updateDrawerOutputs();
  }

  /* A slider drag fires dozens of input events a second: refilter the grid at most once per frame */
  var filterQueued = false;
  function queueFilter() {
    if (filterQueued) return;
    filterQueued = true;
    requestAnimationFrame(function() {
      filterQueued = false;
      filterProducts();
      if (typeof refreshSizer === 'function') refreshSizer();
    });
  }

  /* Wire input events on every axis control */
  Object.keys(AXES).forEach(function(k) {
    var axis = AXES[k];
    if (axis.kind === 'range') {
      axis.el.addEventListener('input', function() {
        updateOutputs();
        queueFilter();
      });
    } else if (axis.kind === 'radio' || axis.kind === 'checklist') {
      axis.els.forEach(function(e) {
        e.addEventListener('change', function() {
          filterProducts();
          if (typeof refreshSizer === 'function') refreshSizer();
        });
      });
    } else if (axis.kind === 'select') {
      axis.el.addEventListener('change', function() {
        filterProducts();
        if (typeof refreshSizer === 'function') refreshSizer();
      });
    } else if (axis.kind === 'quickpick') {
      axis.el.addEventListener('click', function() {
        var pressed = axis.el.getAttribute('aria-pressed') === 'true';
        axis.el.setAttribute('aria-pressed', pressed ? 'false' : 'true');
        axis.el.classList.toggle('is-active', !pressed);
        filterProducts();
        if (typeof refreshSizer === 'function') refreshSizer();
      });
    }
  });
  catChecks.forEach(function(c) { c.addEventListener('change', filterProducts); });
  if (clearBtn) clearBtn.addEventListener('click', resetFilters);

  var statusClear = document.getElementById('co-grid-status-clear');
  var noresultsClear = document.getElementById('co-grid-noresults-clear');
  if (statusClear) statusClear.addEventListener('click', resetFilters);
  if (noresultsClear) noresultsClear.addEventListener('click', resetFilters);

  /* Mobile filter overlay */
  var mobileTrigger = document.getElementById('co-filters-mobile-trigger');
  var filterPanel = document.getElementById('co-filters');
  var backdrop = document.getElementById('co-filters-backdrop');
  var mobileClose = document.getElementById('co-filters-mobile-close');
  var mobileSave = document.getElementById('co-filters-mobile-save');

  function openFilters() {
    if (!filterPanel) return;
    document.body.classList.add('co-filters-open');
    filterPanel.classList.add('is-open');
    if (backdrop) backdrop.classList.add('is-visible');
  }
  function closeFilters() {
    if (!filterPanel) return;
    filterPanel.classList.remove('is-open');
    if (backdrop) backdrop.classList.remove('is-visible');
    document.body.classList.remove('co-filters-open');
  }
  if (mobileTrigger) mobileTrigger.addEventListener('click', openFilters);
  if (mobileClose) mobileClose.addEventListener('click', closeFilters);
  if (mobileSave) mobileSave.addEventListener('click', closeFilters);
  if (backdrop) backdrop.addEventListener('click', closeFilters);

  updateOutputs();
  /* Run once on load ONLY when an alwaysEvaluate axis exists (e.g. state_match
     hiding state clones), so those products are hidden before any interaction.
     Other collections keep their original behavior (no init filter pass), which
     avoids prematurely hiding products that have no system_specs. */
  var hasAlwaysEval = Object.keys(AXES).some(function(k) { return AXES[k].alwaysEvaluate; });
  if (hasAlwaysEval) filterProducts();

  /* =============================================================
     Generic sizing engine + cross-page water profile
     =============================================================
     Reads collection sizing data from #co-sizing-data (sizing_rule
     + addon_rules + sizing rows) and per-product specs from
     #co-filter-specs. Renders a live recommendation, saves the
     profile to localStorage, and tags product cards with badges.
     ============================================================= */
  var STORAGE_KEY = 'maw_water_profile';
  var dataEl = dataElGlobal;
  var recPanel = document.getElementById('co-rec-panel');
  var recInner = document.getElementById('co-rec-panel-inner');
  /* The sizing panel is switched off in Liquid (no #co-rec-panel); the recommendation form must still work. */
  if (!dataEl || !recPanel) { wireRecommendationForm(); return; }

  var SIZING;
  try { SIZING = JSON.parse(dataEl.textContent); }
  catch (err) { console.error('co-sizer: bad sizing data', err); return; }
  if (!SIZING || typeof SIZING !== 'object') { wireRecommendationForm(); return; }
  if (!SIZING.rows || !SIZING.rows.length) { wireRecommendationForm(); return; }

  /* ---- Parse helpers ------------------------------------------- */
  function parseFirstNumber(str) {
    if (str == null) return null;
    var m = String(str).match(/(\d+(?:\.\d+)?)/);
    return m ? parseFloat(m[1]) : null;
  }
  function parseHouseholdRange(str) {
    if (!str) return { min: 0, max: 99 };
    var s = String(str);
    if (/\+/.test(s)) {
      var lo = parseFirstNumber(s);
      return { min: lo || 0, max: 99 };
    }
    var nums = s.match(/(\d+)/g);
    if (!nums || !nums.length) return { min: 0, max: 99 };
    if (nums.length === 1) return { min: parseInt(nums[0], 10), max: parseInt(nums[0], 10) };
    return { min: parseInt(nums[0], 10), max: parseInt(nums[1], 10) };
  }

  var ABSOLUTE_PUMP_FLOOR = parseFloat(SIZING.absolute_pump_floor_gpm) || 0;
  var HEAVY_LOAD_THRESHOLD = SIZING.heavy_load_threshold != null ? parseFloat(SIZING.heavy_load_threshold) : null;
  var HEAVY_LOAD_MESSAGE = SIZING.heavy_load_message || '';
  var MIN_TANK_LARGE_HOUSEHOLD = parseFloat(SIZING.min_tank_for_large_household_cu_ft) || 0;
  var LARGE_HOUSEHOLD_THRESHOLD = parseFloat(SIZING.large_household_threshold) || 0;
  var PRIMARY_AXIS = SIZING.primary_axis_key || null;
  var HOUSEHOLD_AXIS = SIZING.household_axis_key || 'household';
  var FLOW_AXIS = SIZING.flow_axis_key || null;

  function tankBackwashMin(sizeVal) {
    var steps = (SIZING.tank_backwash_steps || []).slice().sort(function(a, b) {
      return a.tank_size_cu_ft - b.tank_size_cu_ft;
    });
    var min = 0;
    for (var i = 0; i < steps.length; i++) {
      if (sizeVal >= steps[i].tank_size_cu_ft) min = steps[i].min_backwash_gpm;
    }
    return min;
  }

  /* Build ROWS by joining each sizing_row with its product's spec */
  var ROWS = SIZING.rows.map(function(r) {
    var spec = r.product_handle ? SPECS[r.product_handle] : null;
    var primaryMax = null;
    if (spec && PRIMARY_AXIS && spec.contaminants && spec.contaminants[PRIMARY_AXIS]) {
      primaryMax = spec.contaminants[PRIMARY_AXIS].max_input;
    }
    if (primaryMax == null) primaryMax = parseFirstNumber(r.capacity);
    var sizeVal = (spec && spec.tank_size_cu_ft) || parseFirstNumber(r.size_label) || 0;
    var flowGpm = (spec && spec.working_flow_gpm) || parseFirstNumber(r.working_flow_text) || parseFirstNumber(r.flow_rate) || 0;
    var hh = parseHouseholdRange(r.household);
    if (spec && (spec.min_household != null || spec.max_household != null)) {
      hh = { min: spec.min_household || hh.min, max: spec.max_household || hh.max };
    }
    return {
      raw: r, handle: r.product_handle || '', spec: spec || null,
      primary_max: primaryMax || 0, size_value: sizeVal,
      flow_gpm: flowGpm, household: hh
    };
  }).sort(function(a, b) { return a.primary_max - b.primary_max; });

  /* ---- Rule evaluator ------------------------------------------ */
  function ruleMatches(rule, profile) {
    var v = profile[rule.trigger_axis_key];
    var op = rule.trigger_operator;
    if (op === 'is_true') return !!v;
    if (op === 'is_false') return v === false;
    if (v == null) return false;
    var t1 = rule.trigger_value, t2 = rule.trigger_value_2;
    if (op === 'lt') return parseFloat(v) < parseFloat(t1);
    if (op === 'gt') return parseFloat(v) > parseFloat(t1);
    if (op === 'between') return parseFloat(v) >= parseFloat(t1) && parseFloat(v) <= parseFloat(t2);
    if (op === 'equals') return parseFloat(v) === parseFloat(t1);
    return false;
  }
  function pickRecommendedProduct(rule, profile) {
    if (!rule.recommended_product && !rule.recommended_product_bw) return null;
    if (rule.heavy_load_axis_key && rule.heavy_load_value != null) {
      var loadVal = profile[rule.heavy_load_axis_key];
      if (loadVal != null && parseFloat(loadVal) >= parseFloat(rule.heavy_load_value) && rule.recommended_product_bw) {
        return rule.recommended_product_bw;
      }
    }
    return rule.recommended_product || rule.recommended_product_bw;
  }

  function recommend(profile) {
    if (!SIZING) return { kind: 'empty', recs: [], flags: [] };
    var sortedRules = (SIZING && SIZING.addon_rules ? SIZING.addon_rules : []).slice().sort(function(a, b) {
      return (a.display_order || 99) - (b.display_order || 99);
    });

    /* 1. Redirect short-circuit */
    for (var i = 0; i < sortedRules.length; i++) {
      var rr = sortedRules[i];
      if (rr.flag_kind === 'redirect' && rr.redirect_to_expert && ruleMatches(rr, profile)) {
        return {
          kind: 'redirect',
          title: rr.redirect_title || ('Talk to ' + (SIZING.expert_name || 'us')),
          message: rr.redirect_message || '',
          ctaText: 'Call ' + (SIZING.expert_name || 'us') + ' &raquo;',
          ctaHref: 'tel:' + SIZING.phone_clean,
          flags: []
        };
      }
    }

    var primary = PRIMARY_AXIS ? profile[PRIMARY_AXIS] : null;
    var hh = profile[HOUSEHOLD_AXIS];
    var flow = FLOW_AXIS ? profile[FLOW_AXIS] : null;

    if (primary == null || hh == null) return null;

    /* 2. Match a sizing row by primary capacity AND household range */
    var match = null;
    for (var j = 0; j < ROWS.length; j++) {
      var row = ROWS[j];
      if (primary <= row.primary_max && hh >= row.household.min && hh <= row.household.max) {
        match = row; break;
      }
    }
    if (!match) {
      for (var k = 0; k < ROWS.length; k++) {
        if (primary <= ROWS[k].primary_max) { match = ROWS[k]; break; }
      }
    }

    /* 3. Heavy household upgrade */
    if (match && LARGE_HOUSEHOLD_THRESHOLD && hh >= LARGE_HOUSEHOLD_THRESHOLD &&
        match.size_value && match.size_value < MIN_TANK_LARGE_HOUSEHOLD) {
      var bumped = ROWS.find(function(r) { return r.size_value && r.size_value >= MIN_TANK_LARGE_HOUSEHOLD; });
      if (bumped) match = bumped;
    }

    /* 4. Flow-rate downsize */
    if (match && flow != null) {
      if (flow < tankBackwashMin(match.size_value)) {
        var altMatch = null;
        for (var dg = ROWS.length - 1; dg >= 0; dg--) {
          var rd = ROWS[dg];
          if (flow >= tankBackwashMin(rd.size_value) && (primary == null || primary <= rd.primary_max)) {
            altMatch = rd; break;
          }
        }
        if (altMatch) match = altMatch;
      }
    }

    /* 5. Built-in capacity / flow flags + addon rule emission */
    var flags = [];
    var recs = [];

    if (HEAVY_LOAD_THRESHOLD != null && primary > HEAVY_LOAD_THRESHOLD) {
      flags.push({ kind: 'alert', icon: '!', text: HEAVY_LOAD_MESSAGE });
    } else if (match && primary > match.primary_max) {
      flags.push({
        kind: 'warn', icon: '!',
        text: '<strong>This tank tops out at ' + match.primary_max + '.</strong> Your value of ' + primary + ' exceeds it. Step up to the next size.'
      });
    }

    if (flow != null && FLOW_AXIS) {
      if (ABSOLUTE_PUMP_FLOOR && flow < ABSOLUTE_PUMP_FLOOR) {
        flags.push({
          kind: 'alert', icon: '!',
          text: '<strong>' + flow + ' GPM is below the ' + ABSOLUTE_PUMP_FLOOR + ' GPM minimum.</strong> Call <a href="tel:' + SIZING.phone_clean + '">' + (SIZING.expert_name || 'us') + '</a>.'
        });
      } else if (match) {
        var bwMin = tankBackwashMin(match.size_value);
        if (bwMin && flow < bwMin) {
          flags.push({
            kind: 'warn', icon: '!',
            text: '<strong>This tank needs ' + bwMin + ' GPM to backwash, your well delivers ' + flow + ' GPM.</strong> Call <a href="tel:' + SIZING.phone_clean + '">' + SIZING.phone_display + '</a>.'
          });
        } else if (bwMin) {
          flags.push({
            kind: 'good', icon: '\u2713',
            text: '<strong>Well pump fits this tank.</strong> ' + flow + ' GPM covers the ' + bwMin + ' GPM backwash minimum.'
          });
        }
      }
    }

    /* Apply addon rules (skip redirect kind, already handled in step 1) */
    for (var ri = 0; ri < sortedRules.length; ri++) {
      var rule = sortedRules[ri];
      if (rule.flag_kind === 'redirect') continue;
      if (!ruleMatches(rule, profile)) continue;

      var prod = pickRecommendedProduct(rule, profile);
      var collectionLink = rule.recommended_collection;

      /* Skip rules whose built-in equivalent already fired (heavy load on primary
         axis, absolute pump floor on flow axis) so we don't double-emit. */
      var skipBuiltIn = false;
      if (rule.trigger_axis_key === PRIMARY_AXIS && rule.trigger_operator === 'gt' &&
          HEAVY_LOAD_THRESHOLD != null && parseFloat(rule.trigger_value) === HEAVY_LOAD_THRESHOLD &&
          !prod && !collectionLink) {
        skipBuiltIn = true;
      }
      if (rule.trigger_axis_key === FLOW_AXIS && rule.trigger_operator === 'lt' &&
          ABSOLUTE_PUMP_FLOOR && parseFloat(rule.trigger_value) === ABSOLUTE_PUMP_FLOOR &&
          !prod && !collectionLink) {
        skipBuiltIn = true;
      }
      if (skipBuiltIn) continue;

      if (prod || collectionLink) {
        recs.push({
          product: prod,
          collection: collectionLink,
          kind: rule.flag_kind || 'note',
          reason: rule.reason_html || rule.flag_text || ''
        });
      } else if (rule.flag_text) {
        flags.push({
          kind: rule.flag_kind || 'note',
          icon: rule.flag_kind === 'good' ? '\u2713' : '!',
          text: rule.flag_text
        });
      }
    }

    return { kind: 'match', match: match, flags: flags, recs: recs };
  }

  /* ---- localStorage helpers ----------------------------------- */
  function loadProfile() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var p = JSON.parse(raw);
      return p && typeof p === 'object' ? p : null;
    } catch (e) { return null; }
  }
  function saveProfile(p) {
    try { p.updated_at = new Date().toISOString(); localStorage.setItem(STORAGE_KEY, JSON.stringify(p)); } catch (e) {}
  }
  function clearProfile() { try { localStorage.removeItem(STORAGE_KEY); } catch (e) {} }

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function(c) {
      return { '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' }[c];
    });
  }

  /* ---- Render the recommendation panel ------------------------ */
  function renderRecPanel(profile) {
    var rec = recommend(profile);
    if (!rec) {
      recPanel.hidden = true; recInner.innerHTML = ''; return;
    }
    recPanel.hidden = false;
    var html = '';

    if (rec.kind === 'redirect') {
      html += '<div class="co-rec-redirect">' +
        '<span class="co-rec-redirect-eyebrow">Talk to ' + escapeHtml(SIZING.expert_name || 'us') + '</span>' +
        '<h3>' + escapeHtml(rec.title) + '</h3>' +
        '<div>' + rec.message + '</div>' +
        '<a href="' + rec.ctaHref + '" class="co-btn co-btn--primary">' + rec.ctaText + '</a>' +
        '</div>';
    } else if (rec.match) {
      var m = rec.match.raw;
      var subtitle = [];
      if (m.household) subtitle.push(escapeHtml(m.household));
      if (m.bathrooms) subtitle.push(escapeHtml(m.bathrooms) + ' baths');
      if (m.capacity) subtitle.push(escapeHtml(m.capacity));
      if (m.working_flow_text || m.flow_rate) subtitle.push(escapeHtml(m.working_flow_text || m.flow_rate));

      var tagline = '';
      if (rec.match.spec && rec.match.spec.valve_type && rec.match.spec.media_type) {
        tagline = ' &middot; ' + escapeHtml(rec.match.spec.valve_type + ' ' + rec.match.spec.media_type);
      }

      html += '<div class="co-rec-card">' +
        (m.product_image ? '<div class="co-rec-card-img"><img src="' + escapeHtml(m.product_image) + '" alt="' + escapeHtml(m.product_title || m.size_label) + '" loading="lazy"></div>' : '') +
        '<div class="co-rec-card-body">' +
          '<span class="co-rec-card-eyebrow">Your match' + (m.badge ? ' &middot; ' + escapeHtml(m.badge) : '') + '</span>' +
          '<h3>' + escapeHtml(m.size_label) + tagline + '</h3>' +
          '<p class="co-rec-card-meta">' + subtitle.join(' &middot; ') + (m.price_text ? ' &middot; <strong>' + escapeHtml(m.price_text) + '</strong>' : '') + '</p>' +
          '<div class="co-rec-card-actions">' +
            (m.product_url ? '<a href="' + escapeHtml(m.product_url) + '" class="co-btn co-btn--green">View this system &raquo;</a>' : '') +
          '</div>' +
        '</div>' +
      '</div>';

      if (rec.recs && rec.recs.length) {
        rec.recs.forEach(function(r) {
          var p = r.product || r.collection;
          if (!p) return;
          var url = (r.product && r.product.url) || (r.collection && r.collection.url) || '#';
          var img = (r.product && r.product.image) || '';
          var title = (r.product && r.product.title) || (r.collection && r.collection.title) || '';
          var priceText = (r.product && r.product.price_text) || '';
          html += '<a class="co-rec-also" href="' + escapeHtml(url) + '" data-kind="' + escapeHtml(r.kind || 'note') + '">' +
            (img ? '<div class="co-rec-also-img"><img src="' + escapeHtml(img) + '" alt="' + escapeHtml(title) + '" loading="lazy"></div>' : '') +
            '<div class="co-rec-also-body">' +
              '<span class="co-rec-also-eyebrow">Also recommended</span>' +
              '<div class="co-rec-also-title">' + escapeHtml(title) + '</div>' +
              '<div class="co-rec-also-reason">' + r.reason + '</div>' +
              '<div class="co-rec-also-foot">' +
                (priceText ? '<span class="co-rec-also-price">' + escapeHtml(priceText) + '</span>' : '') +
                '<span class="co-rec-also-link">View options &raquo;</span>' +
              '</div>' +
            '</div>' +
          '</a>';
        });
      }
    }

    if (rec.flags && rec.flags.length) {
      rec.flags.forEach(function(f) {
        html += '<div class="co-rec-flag co-rec-flag--' + f.kind + '">' +
          '<span class="co-rec-flag-icon" aria-hidden="true">' + (f.icon || '') + '</span>' +
          '<div>' + f.text + '</div>' +
          '</div>';
      });
    }

    recInner.innerHTML = html;
  }

  /* ---- Card badges -------------------------------------------- */
  function applyCardBadges(profile) {
    var rec = recommend(profile);
    var matchHandle = (rec && rec.match) ? rec.match.handle : null;
    var primary = PRIMARY_AXIS ? profile[PRIMARY_AXIS] : null;
    var byHandle = {};
    ROWS.forEach(function(r) { if (r.handle) byHandle[r.handle] = r; });
    var allCards = document.querySelectorAll('.grid__item .grid__card');
    allCards.forEach(function(card) {
      var existing = card.querySelector('.co-card-badge');
      if (existing) existing.remove();
      var link = card.querySelector('a[href*="/products/"]');
      if (!link) return;
      var href = link.getAttribute('href') || '';
      var match = href.match(/\/products\/([^/?#]+)/);
      if (!match) return;
      var handle = match[1];
      var row = byHandle[handle];
      if (!row) return;
      var badge = null;
      if (handle === matchHandle) {
        badge = { text: '\u2713 Right for your water', cls: 'match' };
      } else if (primary != null && primary > row.primary_max) {
        badge = { text: 'Won\'t fully treat ' + primary, cls: 'undersized' };
      } else if (rec && rec.match) {
        badge = { text: 'Also fits your water', cls: 'ok' };
      }
      if (!badge) return;
      var span = document.createElement('span');
      span.className = 'co-card-badge co-card-badge--' + badge.cls;
      span.textContent = badge.text;
      card.appendChild(span);
    });
  }

  /* ---- Drawer field outputs / event wiring -------------------- */
  function updateDrawerOutputs() {
    var ph = document.getElementById('co-f-ph');
    var mn = document.getElementById('co-f-mn');
    var hg = document.getElementById('co-f-hard-gpg');
    var phOut = document.getElementById('co-f-ph-out');
    var mnOut = document.getElementById('co-f-mn-out');
    var hgOut = document.getElementById('co-f-hard-gpg-out');
    if (ph && phOut) phOut.textContent = ph.dataset.touched === 'false' ? '--' : parseFloat(ph.value).toFixed(1);
    if (mn && mnOut) mnOut.textContent = mn.dataset.touched === 'false' ? '--' : parseFloat(mn.value).toFixed(1) + ' ppm';
    if (hg && hgOut) hgOut.textContent = hg.dataset.touched === 'false' ? '--' : Math.round(parseFloat(hg.value)) + ' gpg';
  }
  ['co-f-ph', 'co-f-mn', 'co-f-hard-gpg'].forEach(function(id) {
    var el = document.getElementById(id); if (!el) return;
    function onTouch() { el.dataset.touched = 'true'; updateDrawerOutputs(); refreshSizer(); }
    el.addEventListener('input', onTouch); el.addEventListener('change', onTouch);
  });
  ['co-f-sulfur', 'co-f-ferric', 'co-f-bacteria'].forEach(function(id) {
    var el = document.getElementById(id);
    if (el) el.addEventListener('change', function() { refreshSizer(); });
  });

  function profileHasContent(p) {
    if (!p) return false;
    return Object.keys(p).some(function(k) {
      if (k === 'updated_at' || k === 'last_recommendation_request_at') return false;
      var v = p[k];
      return v != null && v !== false;
    });
  }

  function refreshSizer() {
    /* The rec panel can be commented out in Liquid (we currently hide it
       above the grid because it confuses customers more than it helps).
       In that case the IIFE early-returns above before SIZING/ROWS get
       assigned, but this hoisted function is still callable from the
       slider listeners' closure -- so guard explicitly. */
    if (!recPanel || typeof SIZING === 'undefined' || !SIZING) return;
    var profile = buildProfile();
    renderRecPanel(profile);
    if (profileHasContent(profile)) saveProfile(profile);
    applyCardBadges(profile);
  }

  /* ---- Hydrate sidebar from saved localStorage profile -------- */
  function hydrateSidebar(profile) {
    if (!profile) return;
    Object.keys(AXES).forEach(function(k) {
      var axis = AXES[k];
      var v = profile[k];
      if (v == null) return;
      if (axis.kind === 'range') {
        var fv = parseFloat(v);
        if (!isNaN(fv)) {
          axis.el.value = Math.max(parseFloat(axis.el.min), Math.min(parseFloat(axis.el.max), fv));
        }
      } else if (axis.kind === 'radio') {
        axis.els.forEach(function(e) { e.checked = (e.value === v); });
      }
    });
    function setTouchedRange(id, v) {
      var el = document.getElementById(id);
      if (!el || v == null) return;
      el.value = Math.max(parseFloat(el.min), Math.min(parseFloat(el.max), v));
      el.dataset.touched = 'true';
    }
    function setCheck(id, v) {
      var el = document.getElementById(id);
      if (el) el.checked = !!v;
    }
    if (profile.ph != null) setTouchedRange('co-f-ph', profile.ph);
    if (profile.manganese_ppm != null) setTouchedRange('co-f-mn', profile.manganese_ppm);
    if (profile.hardness_gpg != null) setTouchedRange('co-f-hard-gpg', profile.hardness_gpg);
    setCheck('co-f-sulfur', profile.sulfur_smell);
    setCheck('co-f-ferric', profile.ferric);
    setCheck('co-f-bacteria', profile.iron_bacteria);

    if (profile.ph != null || profile.manganese_ppm != null ||
        profile.hardness_gpg != null || profile.sulfur_smell ||
        profile.ferric || profile.iron_bacteria) {
      var drawer = document.getElementById('co-filter-drawer');
      if (drawer) drawer.open = true;
    }
    updateDrawerOutputs();
  }

  /* Boot: rehydrate from localStorage */
  var saved = loadProfile();
  if (saved) {
    hydrateSidebar(saved);
    refreshSizer();
    updateOutputs();
    filterProducts();
  }
  updateDrawerOutputs();

  /* =============================================================
     Recommendation form (Section 15)
     =============================================================
     Pre-fills the water-test textarea from the localStorage profile
     so customers who already used the sidebar sizer don't retype
     their numbers.
     ============================================================= */
  wireRecommendationForm();

  function wireRecommendationForm() {
  var recForm = document.getElementById('co-rec-form');
  if (!recForm || recForm.dataset.wired) return;
  recForm.dataset.wired = '1';
  var recSuccess = document.getElementById('co-rec-success');

  function prettyAxisLabel(key) {
    var axis = AXES[key];
    if (axis && axis.label) return axis.label;
    return key.replace(/_/g, ' ').replace(/\b\w/g, function(c) { return c.toUpperCase(); });
  }
  function axisDisplayValue(key, val) {
    var axis = AXES[key];
    if (!axis) return val;
    if (axis.kind === 'range' && axis.unit) return val + ' ' + axis.unit;
    return val;
  }
  function buildWaterTestPrefill(profile) {
    if (!profile) return '';
    var lines = [];
    /* Emit every active filter axis (range or radio) */
    Object.keys(AXES).forEach(function(k) {
      var v = profile[k];
      if (v == null || v === false) return;
      lines.push(prettyAxisLabel(k) + ': ' + axisDisplayValue(k, v));
    });
    /* Emit drawer fields */
    var drawerLabels = { ph: 'pH', manganese_ppm: 'Manganese (ppm)', hardness_gpg: 'Hardness (gpg)' };
    Object.keys(drawerLabels).forEach(function(k) {
      if (profile[k] != null && AXES[k] === undefined) {
        lines.push(drawerLabels[k] + ': ' + profile[k]);
      }
    });
    /* Emit symptom flags */
    var symptomLabels = {
      sulfur_smell: 'Sulfur smell: yes',
      ferric: 'Ferric (already-orange water): yes',
      iron_bacteria: 'Iron bacteria / pink slime: yes'
    };
    Object.keys(symptomLabels).forEach(function(k) {
      if (profile[k]) lines.push(symptomLabels[k]);
    });
    return lines.join('\n');
  }

  /* Pre-fill on boot */
  var savedForForm = loadProfile();
  if (savedForForm) {
    var prefill = buildWaterTestPrefill(savedForForm);
    var testEl = document.getElementById('co-rec-test');
    if (prefill && testEl && !testEl.value) testEl.value = prefill;
  }

  recForm.addEventListener('submit', function (e) {
    e.preventDefault();
    var name = (document.getElementById('co-rec-name').value || '').trim();
    var email = (document.getElementById('co-rec-email').value || '').trim();
    var phone = (document.getElementById('co-rec-phone').value || '').trim();
    var test = (document.getElementById('co-rec-test').value || '').trim();
    var notes = (document.getElementById('co-rec-notes').value || '').trim();

    if (!name || !email) {
      recForm.reportValidity();
      return;
    }

    var subject = '[Recommendation request] ' + name;
    var bodyParts = [
      'Hi ' + ((SIZING && SIZING.expert_name) || 'Aidan') + ',',
      '',
      'I came from the ' + ((SIZING && SIZING.collection_label) || 'collection') + ' page on midatlanticwater.net and would like a sized recommendation.',
      '',
      'Name: ' + name,
      'Email: ' + email,
      phone ? ('Phone: ' + phone) : '',
      '',
      '--- Water test ---',
      test || '(none entered)',
      '',
      '--- Other notes ---',
      notes || '(none)',
      '',
      'Thanks!'
    ].filter(function (l) { return l !== ''; });

    var mailto = 'mailto:support@midatlanticwater.net?subject=' +
      encodeURIComponent(subject) +
      '&body=' + encodeURIComponent(bodyParts.join('\n'));

    /* Open the user's mail client */
    window.location.href = mailto;

    /* Log a prefill-style profile so this customer keeps their data on
       subsequent visits */
    if (test) {
      var existing = loadProfile() || {};
      existing.last_recommendation_request_at = new Date().toISOString();
      saveProfile(existing);
    }

    /* Show the success state after a short delay (so the mailto: window
       opens first) */
    setTimeout(function () {
      recForm.style.display = 'none';
      if (recSuccess) recSuccess.hidden = false;
    }, 400);
  });
  }
})();
